import React from "react";
import { useTheme } from "../context/ThemeContext";

const ThemeToggle = () => {
  const { isLight, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={isLight ? "Switch to dark mode" : "Switch to light mode"}
      title={isLight ? "Switch to dark mode" : "Switch to light mode"}
    >
      <span className="theme-toggle-icon" aria-hidden="true">{isLight ? "☾" : "☀"}</span>
      <span>{isLight ? "Dark" : "Light"}</span>
    </button>
  );
};

export default ThemeToggle;
